// extracted by mini-css-extract-plugin
export default {"marker":"Map-marker","marker--selected":"Map-marker--selected"};